export default __webpack_public_path__ + "static/media/smartphone.e50691af.svg";